import React, { FunctionComponent } from "react";
import { IIconProps } from "../icon";

export const EmojiSad: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 52 52" {...rest}>
      <g
        id="Icons/Body/Emoji-Sad"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="streamline-smiley-sad-crying--messages-chat-smileys--24x24"
          transform="translate(3.000000, 3.000000)"
          stroke="#222222"
          strokeWidth="3"
        >
          <path
            d="M0,23 C0,35.7025492 10.2974508,46 23,46 C35.7025492,46 46,35.7025492 46,23 C46,10.2974508 35.7025492,0 23,0 C10.2974508,0 0,10.2974508 0,23 Z"
            id="Path"
          ></path>
          <path
            d="M35.3648,35.2666667 C33.0353951,30.5656381 28.2424143,27.5914812 22.9959111,27.5914812 C17.7494079,27.5914812 12.9564271,30.5656381 10.6270222,35.2666667"
            id="Path"
          ></path>
          <path
            d="M15.3333333,16.1 C15.7567516,16.1 16.1,16.4432484 16.1,16.8666667 C16.1,17.290085 15.7567516,17.6333333 15.3333333,17.6333333 C14.909915,17.6333333 14.5666667,17.290085 14.5666667,16.8666667 C14.5666667,16.4432484 14.909915,16.1 15.3333333,16.1"
            id="Path"
          ></path>
          <path
            d="M30.6666667,16.1 C31.090085,16.1 31.4333333,16.4432484 31.4333333,16.8666667 C31.4333333,17.290085 31.090085,17.6333333 30.6666667,17.6333333 C30.2432484,17.6333333 29.9,17.290085 29.9,16.8666667 C29.9,16.4432484 30.2432484,16.1 30.6666667,16.1"
            id="Path"
          ></path>
          <path
            d="M39.8666667,25.0444444 C39.8666667,26.4558388 38.7225054,27.5999999 37.3111111,27.5999999 C35.8997168,27.5999999 34.7555556,26.4558388 34.7555556,25.0444444 C35.311207,23.2080695 36.175402,21.4796794 37.3111111,19.9333333 C38.4468202,21.4796794 39.3110153,23.2080695 39.8666667,25.0444444 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  );
};
